import {
  NetworkAffiliationDetails,
  ProviderDetails,
  ProviderLocation,
} from '../../models/ProviderDetails';

export type ProviderDetailsMaestroResponse = ProviderDetails & {
  locations: ProviderLocation[];
  networkAffiliationData?: NetworkAffiliationDetails | null;
};

export type GuestAcquisitionRequestData = {
  client: string;
  clientProdCode: string;
  enforceDistinctPCP: boolean;
  fipsCode: string;
  planTypes: string[];
  targetUrl: string;
  transactionId: string;
  year: string;
  zip: string;
};

export interface GuestAcquisitionState {
  isNavigatingMaestro: boolean;
  setIsNavigatingMaestro: (isNavigatingMaestro: boolean) => void;
  isNavigatingFromJarvis: boolean;
  setIsNavigatingFromJarvis: (isNavigatingFromJarvis: boolean) => void;
  requestData: GuestAcquisitionRequestData;
  setRequestData: (requestData: GuestAcquisitionRequestData) => void;
  clearRequestData: () => void;
  responseData: ProviderDetailsMaestroResponse[];
  setResponseData: (responseData: ProviderDetailsMaestroResponse[]) => void;
  clearResponseData: () => void;
  isUpdateProvider: boolean;
  setIsUpdateProvider: (isUpdateProvider: boolean) => void;
  referringUrl: string;
  setReferringUrl: (referringUrl: string) => void;
}

export enum StoreKeys {
  IS_NAVIGATING_MAESTRO = 'isNavigatingMaestro',
  SET_IS_NAVIGATING_MAESTRO = 'setIsNavigatingMaestro',
  IS_NAVIGATING_FROM_JARVIS = 'isNavigatingFromJarvis',
  SET_IS_NAVIGATING_FROM_JARVIS = 'setIsNavigatingFromJarvis',
  REQUEST_DATA = 'requestData',
  SET_REQUEST_DATA = 'setRequestData',
  CLEAR_REQUEST_DATA = 'clearRequestData',
  RESPONSE_DATA = 'responseData',
  SET_RESPONSE_DATA = 'setResponseData',
  CLEAR_RESPONSE_DATA = 'clearResponseData',
  IS_UPDATE_PROVIDER = 'isUpdateProvider',
  SET_IS_UPDATE_PROVIDER = 'setIsUpdateProvider',
  REFERRING_URL = 'referringUrl',
  SET_REFERRING_URL = 'setReferringUrl',
}

export const initialState = {
  [StoreKeys.IS_NAVIGATING_MAESTRO]: false,
  [StoreKeys.IS_NAVIGATING_FROM_JARVIS]: false,
  [StoreKeys.REQUEST_DATA]: {} as GuestAcquisitionRequestData,
  [StoreKeys.RESPONSE_DATA]: [] as ProviderDetailsMaestroResponse[],
  [StoreKeys.IS_UPDATE_PROVIDER]: false,
  [StoreKeys.REFERRING_URL]: '',
};

export const PERSIST_KEYS = [StoreKeys.REQUEST_DATA, StoreKeys.RESPONSE_DATA];
